// ReportesHomeXL - Sprint 44 Fase 3 Vista 8.
// Hub de los 4 reportes contables. Tokens + dark + hover.
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ensureKeyframes, injectCSS } from '../../../design/motion';

const CSS_ID = 'xl-rep-home-css';
const CSS = `
.xl-page { padding: 24px; font-family: var(--xl-font-sans); color: var(--xl-color-text) }
.xl-page__title { font-size: 22px; font-weight: 600; margin: 0 }
.xl-page__sub { font-size: 13px; color: var(--xl-color-text-secondary); margin: 2px 0 16px }

.xl-rep-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
@media (max-width: 720px) { .xl-rep-grid { grid-template-columns: 1fr } }

.xl-rep-card {
  display: block;
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  box-shadow: var(--xl-shadow-sm);
  padding: 18px;
  text-decoration: none;
  transition: border-color 120ms cubic-bezier(0,0,0.2,1),
              box-shadow 120ms cubic-bezier(0,0,0.2,1);
}
.xl-rep-card:hover {
  border-color: rgba(46, 55, 69, 0.25);
  box-shadow: var(--xl-shadow-md);
}
.xl-rep-card:focus-visible { outline: 2px solid var(--xl-color-focus); outline-offset: 2px }
.xl-rep-card__title {
  font-size: 15px; font-weight: 600;
  color: var(--xl-color-text);
  margin-bottom: 4px;
}
.xl-rep-card__desc {
  font-size: 13px; color: var(--xl-color-text-secondary);
  line-height: 1.45;
}
`;

const REPORTES = [
  { to: '/contabilidad/reportes/balance', label: 'Balance general',
    desc: 'Activos, pasivos y patrimonio a una fecha de corte.' },
  { to: '/contabilidad/reportes/estado-resultados', label: 'Estado de resultados',
    desc: 'Ingresos, gastos y utilidad en un rango de fechas.' },
  { to: '/contabilidad/reportes/libro-mayor', label: 'Libro mayor',
    desc: 'Movimientos de una cuenta con saldo acumulado.' },
  { to: '/contabilidad/reportes/auxiliar-tercero', label: 'Auxiliar por tercero',
    desc: 'Movimientos por cliente o proveedor.' },
];

export default function ReportesHomeXL() {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  return (
    <div className="xl-page">
      <h2 className="xl-page__title">Reportes contables</h2>
      <p className="xl-page__sub">NIIF \u00b7 multi-tenant \u00b7 solo asientos publicados.</p>
      <div className="xl-rep-grid">
        {REPORTES.map((r) => (
          <Link key={r.to} to={r.to} className="xl-rep-card">
            <div className="xl-rep-card__title">{r.label}</div>
            <div className="xl-rep-card__desc">{r.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
